<template>
    <div class="contacto">
      <div class="main col-lg-12">
        <h5 class="col-lg-12 mb-5 mt-5 pt-5">Panel - Planes.</h5>
        <div class="container " id="top">    
          <b-button pill @click="createPlan" class="btn btn_plan prime_btn"><i class="fa fa-plus mr-3"></i>Nuevo título</b-button>
          <PlanesEdit @editPlan="editPlan" @deletePlan="deletePlan" ref="planesComp"/>
        </div>
        
        <b-modal ref="plan-modal" id="plan-modal" no-close-on-backdrop scrollable hide-header>
     <div class="d-block text-center">
        <div class="col-lg-12 text-right">
          <h2>{{form_title}}</h2>
            <ValidationObserver ref="form">
                <b-form id="form" class="form-container">
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label >Título</label>
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-input v-model="titulo_plan.nombre"  type="text" placeholder="Título"/>
                                <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="form-group text-left">
                          <ValidationProvider rules="required"  v-slot="{ errors }">
                            <b-form-radio v-model="titulo_plan.tipo" name="rbtTipoT" value="basic">Plan BASIC</b-form-radio>
                            <b-form-radio v-model="titulo_plan.tipo" name="rbtTipoT" value="prime">Plan PREMIUM</b-form-radio>
                            <b-form-radio v-model="titulo_plan.tipo" name="rbtTipoT" value="ambos">Ambos planes</b-form-radio>
                            <span class="error">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                        <div class="form-group text-left">
                            <b-form-checkbox type="checkbox" v-model="titulo_plan.activo">Visible</b-form-checkbox>
                        </div>
                      </div>

                      <div class="col-lg-12">
                        <b-button pill class="btnSend float-right" title="Añadir elemento" @click="addPlan()"><i class="fa fa-plus mr-3"></i> Añadir subtitulo</b-button>
                      </div>
                      
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label >Nuevo subtítulo</label>
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-input v-model="nombreS" name="valorS"  type="text" placeholder="Subtítulo"/>
                                <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="form-group text-left">
                          <ValidationProvider rules="required"  v-slot="{ errors }">
                            <b-form-radio v-model="tipoS" name="rbtTipoS" value="basic">Plan BASIC</b-form-radio>
                            <b-form-radio v-model="tipoS" name="rbtTipoS" value="prime">Plan PREMIUM</b-form-radio>
                            <b-form-radio v-model="tipoS" name="rbtTipoS" value="ambos">Ambos planes</b-form-radio>
                            <span class="error">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                        <div class="form-group text-left">
                            <b-form-checkbox type="checkbox" v-model="activoS">Visible</b-form-checkbox>
                        </div>
                      </div>
                    </div>
                    <hr/>
                  <div v-for="(item,key) in titulo_plan.subtitulos" :value="item.value" :key="item.value">
                    <div class="row">
                      <div class="col-lg-12">
                        <b-link :title="'Eliminar '+ item.nombre" class="btnDelete" @click="removePlan(item.orden)"></b-link>
                      </div>
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label >Subtítulo {{item.orden}}</label>
                            <ValidationProvider v-slot="{ errors }">
                                <b-form-input v-model="item.nombre" name="valor1" type="text" placeholder="Subtítulo"/>
                                <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="form-group text-left">
                          <ValidationProvider rules="required"  v-slot="{ errors }">
                            <b-form-radio v-model="item.tipo" :name="'rbtTipoS'+item.orden" value="basic">Plan BASIC</b-form-radio>
                            <b-form-radio v-model="item.tipo" :name="'rbtTipoS'+item.orden" value="prime">Plan PREMIUM</b-form-radio>
                            <b-form-radio v-model="item.tipo" :name="'rbtTipoS'+item.orden" value="ambos">Ambos planes</b-form-radio>
                            <span class="error">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                        <div class="form-group text-left">
                            <b-form-checkbox type="checkbox" v-model="item.activo">Visible</b-form-checkbox>
                        </div>
                      </div>
                    </div>
                    <hr v-if="key+1 != titulo_plan.subtitulos.length"/>
                  </div>
                </b-form>
            </ValidationObserver>
        </div> 
      </div>
    <template #modal-footer="{}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button v-show="!loading" type="submit" pill class="btnSend" @click="updatePlanes()">Guardar Cambios</b-button>
      <b-link v-show="!loading" class="btnCancel" @click="reset();"><b-icon icon="x"></b-icon></b-link>
      <b-button v-show="loading" class="btnSend" pill disabled="disabled"><b-spinner small class="mr-2"></b-spinner>ENVIANDO</b-button>
    </template>
  </b-modal>
      </div>
    </div>
</template>

<script>

import env from '@/plugins/enviroment';
import planesApi from "../api/planes";
import PlanesEdit from '@/components/PlansEdit.vue';
import {ValidationProvider,ValidationObserver} from 'vee-validate';
import {mapState,mapActions} from "vuex";
import Notify from "@/plugins/notify";
import Swal from "sweetalert2";


export default {
  name: 'planes-manager',
  components: {
      ValidationProvider,
      ValidationObserver,
      PlanesEdit
  },
  data() {
      return {
        titulo_plan:{tipo:"ambos",activo:true,subtitulos:[]},
        form_title:"",
        footers:[],
        footersObj:[],
        footerPackage:{footer:[],eliminados:[]},
        nombreS:"",
        tipoS:"ambos",
        activoS:true,
        eliminados:[],
        cliker:null,
        loading:false,
        textArea:false,
        timeout:null
      }
    },
    methods: {
      editPlan(data){
        this.titulo_plan = JSON.parse(JSON.stringify(data));
        this.form_title = "Editar "+data.nombre;
        this.$refs['plan-modal'].show();
      },
      createPlan(){
        this.form_title = "Nuevo título";
        this.$refs['plan-modal'].show();
      },
      deletePlan(data){
        let self = this;
        Notify.Confirm("Espere", "¿Está seguro de eliminar todo el título: "+data.nombre+" y sus subtítulos? Se eliminará permanentemente.", "Aceptar", "Cancelar",
        function OnSucces(){
          planesApi
            .deletePlan(data.id)
            .then(response => {
                Notify.SuccessToast(response.data.message);
                self.$refs.planesComp.getPlanes();
            }).catch(err => {
                console.log("Ocurrio un error eliminar los planes.");
            });
          });
      },
      reset() {
      this.$nextTick(() => {
          this.titulo_plan = {tipo:"ambos",activo:true,subtitulos:[]};
          this.eliminados = [];
          this.nombreS = "";
          this.tipoS = "ambos";
          this.activoS = true;
          this.$refs.form.reset();
          this.$refs['plan-modal'].hide();
        });
      },
      async updatePlanes(){
        this.loading = true;
        
        if(this.titulo_plan.id !== undefined){
          await planesApi
            .updatePlanes(this.titulo_plan)
            .then(response => {
              Notify.Success("¡Excelente!", response.data.message);
              this.reset();
              this.$refs.planesComp.getPlanes();
              this.$refs['plan-modal'].hide();
            }).catch(err => {
              if(err.response.data.error != undefined){
                let error = "";
                for(let item in err.response.data.error){
                  error = err.response.data.error[item][0];
                }
                Notify.Error("No pudimos guardar los cambios", "",error);
              }else
                Notify.Error("No eres tu, somos nostros.", "","Lo sentimos, en este momento no fue posible actualizar el artículo, inténtalo nuevamente.");
            });
        }else{
          await planesApi
            .createPlanes(this.titulo_plan)
            .then(response => {
              Notify.Success("¡Excelente!", response.data.message);
              this.reset();
              this.$refs.planesComp.getPlanes();
              this.$refs['plan-modal'].hide();
            }).catch(err => {
              if(err.response.data.error != undefined){
                let error = "";
                for(let item in err.response.data.error){
                  error = err.response.data.error[item][0];
                }
                Notify.Error("No pudimos guardar los cambios", "",error);
              }else
                Notify.Error("No eres tu, somos nostros.", "","Lo sentimos, en este momento no fue posible actualizar el artículo, inténtalo nuevamente.");
            });
        }
        
      
        this.loading = false;
      },
      async addPlan(){
        var isValid = await this.$refs.form.validate();
        if (!isValid) {
          Notify.WarningToast("Tienes que completar los campos antes de crear un elemento nuevo.");
        }else{
          let orden = 1;
          if(this.titulo_plan.subtitulos.length > 0)
            orden = this.titulo_plan.subtitulos[this.titulo_plan.subtitulos.length-1].orden+1
          this.titulo_plan.subtitulos.push({nombre:this.nombreS,tipo:this.tipoS,activo:this.activoS,orden:orden});
          this.$nextTick(() => {
            this.$refs.form.reset();
            this.nombreS = "";
            this.tipoS = "ambos";
            this.activoS = true;
          });
        }
      },
      removePlan(orden){
        
        let index = this.titulo_plan.subtitulos.findIndex((element) => element.orden  == orden);

        if(this.titulo_plan.subtitulos[index].id !== undefined){
          this.eliminados.push(this.titulo_plan.subtitulos[index].id);
        }

        this.titulo_plan.subtitulos.splice(index,1);
        
        this.titulo_plan.eliminados = this.eliminados;
      },
    },
    created () {
    },
}
</script>

<style scoped>
.btn_plan {
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    background: #1E2144;
    border-radius: 18px;
    letter-spacing: 0.3px;
    border-color: #1E2144 !important;
    color: #FFFFFF;
    padding: 13px 27px;
  }
h3{
  font-family: Muli;
font-style: normal;
font-weight: normal;
font-size: 38px;
line-height: 50px;
align-items: center;
text-align: center;
letter-spacing: 0.2px;
color: #1E2144;
}
.btnEdit{
    content: url("/static/images/icons/edit.svg");
  }

.arrow-down{
    content: url("/static/images/icons/arrow-down.svg");
    margin-right: auto;
    margin-left: auto;
    padding-top:28px;
  }

.vr{
    border-left:0.701478px solid #E0E0E0;
    height:180px;
  }
hr{
  border: 1px solid #E8404E;
}
.btnDelete{
    content: url("/static/images/icons/delete.svg");
  }

.social-part .fa{
        padding-right: 20px;
    }

    .titulo {
        font-family: Muli-Extrabold;
        font-style: normal;
        font-size: 14px;
        line-height: 18px;
        align-items: center;
        text-align: justify;
        letter-spacing: 0.2px;

        color: #1E2245;
    }

    ul > li {
        text-align: left;
    }

    .text-Plan {
        font-family: Muli-Semibold;
        font-style: normal;
        font-size: 9px;
        line-height: 18px;
        align-items: center;
        letter-spacing: 0.2px;

        color: #1E2245;
    }

    p.text-Plan {
        text-align: justify !important;
    }

    .social_btn_m {
        width: 100%;
        padding:10px 10px 10px 10px;
        background:rgb(60, 101, 177,0.3);
        border-radius: 15.0978px;
    }

h2{
  font-family: Muli;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 50px;
  align-items: center;
  text-align: center;
  letter-spacing: 0.2px;
  color: #1E2245;
}

.error{
    font-family: Muli;
    font-style: normal;
    font-size: 12px;
    color:red;
}
    h5 {
        font-family: Muli;
        font-style: normal;
        font-size: 38px;
        line-height: 18px;

        align-items: center;
        text-align: center;
        letter-spacing: 0.2px;
        color: #1E2144;

    }
    .btnDemo {
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    background: #2DB9D1;
    border-color: #2DB9D1 !important;
    border-radius: 18px;
    color: #FFFFFF;
    margin-top: 30px;
    padding: 13px 27px;
  }

  .btnDemo:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }

 .btnSend {
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    background: #2DB9D1;
    border-color: #2DB9D1 !important;
    border-radius: 18px;
    color: #FFFFFF;
    display: block;
    padding: 13px 40px;
  }

  .btnCancel {
    content: url("/static/images/icons/cancel.svg");
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    border-radius: 150px;
    background-color: #F2F2F2;
    border-color: #F2F2F2;
    display: block;
    padding:16px;
    transition:0.2s;
  }

  .btnSend:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }
  .btnCancel:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }

  .cliker-text{
      color:#2DB9D1;
  }

    .main{
        padding: 40px 0;
        background:  url("/static/images/bg_azul_categoria.svg") repeat-x;
    }
    .main input {
        font-size: 11px;
        padding-top: 3px;
        border: 1px solid #E0E0E0;
        border-radius: 5px;
    }
    .main-center{
        margin-top: 30px;
        margin-bottom: 120px !important;
        margin: 0 auto;
        max-width: 600px;
        padding: 10px 40px;
        background:#FFFFFF;
        text-shadow: none;
        -webkit-box-shadow: 1px 10px 20px rgba(107, 127, 153, 0.2);
        -moz-box-shadow: 1px 10px 20px rgba(107, 127, 153, 0.2);
        box-shadow: 1px 10px 20px rgba(107, 127, 153, 0.2);
        border-radius: 25px;
    }

    .form-container {
        padding: 50px 0px;
    }
  .form-group{
    margin-bottom: 30px;
  }
    .form-group > label {
        font-family: Muli;
        font-style: normal;
        font-size: 16px;
        line-height: 16px;
        float:left;
        margin-left:20px;
        letter-spacing: 2px;
        color: #1E2144;
    }
    .placeholder {
        font-family: Muli-Light;
        font-style: normal;
        font-size: 14px;
        line-height: 30px;

        display: flex;
        align-items: center;

        color: #BDBDBD;
    }

    .help {
        margin-top: 50px;
    }

    span.input-group-addon i {
        color: #009edf;
        font-size: 17px;
    }

     @media(max-width: 768px){
          h5 {
        font-size: 24px;
        line-height: 35px;
        margin: 0px 0px;
    }

        .main-center{
      
        background: none;
        -webkit-box-shadow:0px 0px 0px rgba(107, 127, 153, 0.2);
        -moz-box-shadow:0px 0px 0px rgba(107, 127, 153, 0.2);
        box-shadow:0px 0px 0px rgba(107, 127, 153, 0.2);
        }

.btnSend {
    width: 100%;
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    background: #2DB9D1;
    border-color: #2DB9D1 !important;
    border-radius: 18px;
    color: #FFFFFF;
    display: block;
    margin-top: 30px;
    padding: 13px 27px;
  }

  .btnSend:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }
        
     }
</style>